import { Box, SectionHeading } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { useMayManageAliceCardProgram } from '../aliceCardProgram/aliceCardProgramUtils'
import { ConnectedPaymentMethods } from '../aliceCardProgram/ConnectedPaymentMethods'
import { orgRootPath } from '../organization/useOrg'

type AliceCardProgramSectionProps = {
  org?: OrganizationDetailFragment | null
}

export const AliceCardProgramSection = ({ org }: AliceCardProgramSectionProps) => {
  const mayManageAliceCardProgram = useMayManageAliceCardProgram()
  if (!org || !mayManageAliceCardProgram) return null
  if (!org.isOnboarded) return null
  return (
    <Box my={4}>
      <SectionHeading id="alice-card-program" to={`${orgRootPath(org.id)}/alice-card-program`} gutterBottom>
        Contributions Account
      </SectionHeading>
      <ConnectedPaymentMethods org={org} />
    </Box>
  )
}
